import "./style.css";
// React and Redux
import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Libs
import { Col, Row } from "react-bootstrap";
import { Switch } from "shared_components";
// import {
//   Accordion,
//   AccordionItem,
//   AccordionItemHeading,
//   AccordionItemButton,
//   AccordionItemPanel
// } from "react-accessible-accordion";
import { IntercomAPI } from "react-intercom";
import { withTranslation } from "react-i18next";

// Components
import { default as Loadable } from "../_Shared/commonLoadable";
import PlanCards from "../../newDropshipperApp/component/PlanCards";

// Actions
import { setAlertMessage } from "../../actions";
import { showModal } from "../../actions/ui";
import { handleUpgradeRequest, isAnnual } from "../../actions/upgrade.js";
import {
  getPaymentSettings,
  fetchEmpireProrationPrice
} from "../../actions/settings";

// Utils
import ApiCall from "../../utils/apiCall";
// import { addDaystoCurrentDate } from "../../utils/date";
import {
  isCurrentPlanEmpire,
  transpilerPlanAPI,
  isCurrentPlanAnnual,
  // isCurrentPlanPaid,
  isCurrentPlanProfessionalAnnual,
  // isIntegratedStoreWix
} from "../../utils/features";
import { gaEvent } from "../../newDropshipperApp/utils/trackEvents";

// ? Everything below is not used. Remove?
// import { getTrialDays } from "../../utils/plansAndDetails";
// import data from "./data";
// import padlockIcon from "../../assets/lock-icon.svg";
// import approvalIcon from "../../assets/check-icon.svg";
// import fiveStarIcon from "../../assets/5-stars-icon.svg";
// import docIcon from "../../assets/doc-icon.svg";
// import coinIcon from "../../assets/coin-icon.svg";
// import paperIcon from "../../assets/layers-icon.svg";
// import chatIcon from "../../assets/dialogue-icon.svg";
// import fireIcon from "../../assets/fire-icon.svg";
// import invoiceIcon from "../../assets/plan-invoice-icon.svg";
// import avatar01 from "../../assets/testimonial-avatar-01.jpg";
// import avatar02 from "../../assets/testimonial-avatar-02.jpg";
// import executiveAccount from "../../assets/executive-account.svg";
// import productRequest from "../../assets/product-request-icon.svg";
// import bulkCheckout from "../../assets/bulk-checkout.svg";

class Plans extends Component {
  static propTypes = {
    location: PropTypes.object
  };

  state = {
    isLoading: true,
    gettingPlans: true,
    plans: []
  };

  componentWillUnmount() {
    window.location.pathname.includes("/settings") &&
      this.props.isAnnual(false);
    IntercomAPI("trackEvent", "Exit: Plans page");
  }

  upgradeToTier(planName) {
    const { tracker, eventId } = this.props;
    const selectedPlan = this.state.plans.find(
      plan =>
        plan.name === planName && plan.annual === this.props.annualIsChecked
    );

    // TODO: Improve this process so we don't have to call after setState
    this.setState(null, () => {
      this.props.handleUpgradeRequest(
        selectedPlan.id,
        selectedPlan.name,
        { ...tracker, event_id: eventId },
        selectedPlan
      );
    });
  }

  showCreditCardModal(planName) {
    this.props.showModal("PLAN_UPGRADE_CREDIT_CARD", {
      onClick: () => this.upgradeToTier(planName),
      planName,
      isAnnual: this.props.annualIsChecked,
      listing:
        this.props.dataModal === undefined
          ? undefined
          : this.props.dataModal.listing
    });
  }

  onPlanUpgradeButtonClick = planName => {
    gaEvent({
      category: "Upgrade",
      action: `Upgrade ${planName}`
    });
    this.showCreditCardModal(planName);
  };

  async componentDidMount() {
    const { location } = this.props;
    // Currently only used for one_month_trial
    if (
      location &&
      location.query &&
      ["one_month_trial"].includes(location.query.offer_type)
    ) {
      await this.findOrCreateOffer(location.query.offer_type);
    }

    await this.props.getPaymentSettings();
    await this.getPlans();
    await this.props.fetchEmpireProrationPrice();
    this.setState({}, () => this.dataLayerPush());
  }

  dataLayerPush = () => {
    window.dataLayer.push({ event: "optimize.activate" });
  };

  findPlanToUpgradeTo = planName => {
    return this.state.plans.find(plan => {
      return plan.name === planName;
    });
  };

  getPlans() {
    return ApiCall.get("/stores/plans").then(({ json, status }) => {
      this.setState({ plans: transpilerPlanAPI(json.serialised_plans) }, () =>
        this.setState({ gettingPlans: false })
      );
    });
  }

  findOrCreateOffer = async offer_type => {
    return ApiCall.post("/stores/offers", { offer_type });
  };

  findPlan(planName, isAnnual) {
    return this.state.plans.filter(
      plan => plan.name === planName && plan.annual === isAnnual
    );
  }

  // We receive the discount as a percentage, we need to convert it to a number of months and return the appropriate pluralized text
  convertPercentageToMonths = (percent) => {
    const months = Math.round((percent * 12) / 100)
    const remainingText = months === 1 ? this.props.t("Plans.ToggleSection.DiscountSingular") : this.props.t("Plans.ToggleSection.DiscountPlural")
    return `${months} ${remainingText}`
  }

  // ? This is not used, maybe remove? 
  // renderFrozen = () => {
  //   return (
  //     <Row>
  //       <Col xs={12}>
  //         <div className="card mt-30 plan active-plan">
  //           <p className="text-primary mt-20 mb-20">
  //             To continue pushing products make sure your Shopify account is
  //             active and you have Spocket installed
  //           </p>
  //         </div>
  //       </Col>
  //     </Row>
  //   );
  // };

  renderToggleSection = () => {
    if (isCurrentPlanEmpire() && isCurrentPlanAnnual()) {
      return null;
    } else {
      return (
        <Row>
          <Col md={12}>
            {this.props.maxDiscountPercentage && (
              <div className="plans__card_annual_plan">
                <span className="plans__card_annual_plan_regular_text">
                  {this.props.t("Plans.ToggleSection.Monthly")}
                </span>

                <span style={{ margin: "0 15px 0 15px" }}>
                  <Switch
                    checked={
                      isCurrentPlanAnnual()
                        ? this.props.isAnnual(true)
                        : this.props.annualIsChecked
                    }
                    onChange={e =>
                      this.props.isAnnual(e.target.value === "true")
                    }
                  />
                </span>

                <span className="plans__card_annual_plan_regular_text">
                  {this.props.t("Plans.ToggleSection.Yearly")}
                </span>
                <div className="plans__card_annual_plan_bold_text">
                  {this.props.t("Plans.ToggleSection.DiscountInitial")}
                  {" "}
                  {` ${this.convertPercentageToMonths(this.props.maxDiscountPercentage)} `}
                  {this.props.t("Plans.ToggleSection.DiscountFinal")}
                </div>
              </div>
            )}
          </Col>
        </Row>
      );
    }
  };

  renderProrationCost = () => {
    const currentPlan = this.findPlan("Professional", true)[0] || {};
    if (
      isCurrentPlanProfessionalAnnual() &&
      this.props.proratedEmpireCost.price_formatted
    ) {
      return (
        <div className="proration-text">
          {this.props.t("Plans.ProrationCost.TextInitial")}
          {" "}
          {currentPlan.full_price}
          {this.props.t("Plans.ProrationCost.TextFinal")}
          {" "}
          {this.props.proratedEmpireCost.price_formatted}
        </div>
      );
    }
  };

  renderIconContainer(img, alt) {
    return (
      <div className="plan__section-icon-container">
        <img src={img} alt={alt} />
      </div>
    );
  }

  render() {
    return (
      <Loadable
        active={this.state.gettingPlans}
        background="rgba(255, 255, 255, 0.95)"
      >
        {this.renderToggleSection()}
        {this.renderProrationCost()}
        {!this.state.gettingPlans && (
          <PlanCards upgradeToTier={this.onPlanUpgradeButtonClick} />
        )}
      </Loadable>
    );
  }

  // Start -  Secure Section Functions

  // ? This is not used, maybe remove? 
  // renderSecureSection = isAnnual => {
  //   return (
  //     <div className="plans__secure-section">
  //       {this.renderNoRiskSection(isAnnual)}
  //       {this.renderSSLEncryption()}
  //     </div>
  //   );
  // };

  // ? This is not used, maybe remove? 
  // renderSSLEncryption() {
  //   return (
  //     <div className="plans_secure-section-body">
  //       {this.renderIconContainer(padlockIcon, "Padlock Icon")}
  //       <div className="plans__secure-section-description">
  //         <div>128-bit SSL encryption</div>
  //         <div>All your payment details are 100% safe with us.</div>
  //       </div>
  //     </div>
  //   );
  // }

  // ? This is not used, maybe remove? 
  // renderNoRiskSection = isAnnual => {
  //   if (!isCurrentPlanPaid() && !isAnnual && getTrialDays() > 0) {
  //     return (
  //       <div className="plans_secure-section-body">
  //         {this.renderIconContainer(approvalIcon, "Approval Icon")}
  //         <div className="plans__secure-section-description">
  //           <div>There is No Risk</div>
  //           <div>
  //             If Spocket isn’t right for you, cancel before{" "}
  //             {addDaystoCurrentDate(getTrialDays(), "MMMM Do")} and we won’t
  //             charge you.
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }
  // };

  // End -  Secure Section Functions

  // ? This is not used, maybe remove? 
  // renderPlanDescription = () => {
  //   return (
  //     <div>
  //       <Row className="plans__section-rated-dropshippers">
  //         <Col md={12} className="plans__section-description">
  //           <strong>
  //             Our premium plans have all the features you need to scale your
  //             business
  //           </strong>
  //         </Col>
  //       </Row>
  //       <Row className="plans__section__description">
  //         <Col
  //           xs={12}
  //           sm={12}
  //           md={4}
  //           lg={3}
  //           className="plans__section__description_card"
  //         >
  //           {this.renderIconContainer(docIcon, "Doc Icon")}

  //           <div>Unlimited Products</div>
  //           <div>
  //             With hundreds of thousands of products to choose from, there is
  //             something for everyone
  //           </div>
  //         </Col>
  //         <Col
  //           xs={12}
  //           sm={12}
  //           md={4}
  //           lg={3}
  //           className="plans__section__description_card"
  //         >
  //           {this.renderIconContainer(fireIcon, "Fire Icon")}
  //           <div>Premium Products</div>
  //           <div>
  //             Sell high quality, curated, and fast shipping products from the US
  //             and EU
  //           </div>
  //         </Col>
  //         <Col
  //           xs={12}
  //           sm={12}
  //           md={4}
  //           lg={3}
  //           className="plans__section__description_card"
  //         >
  //           {this.renderIconContainer(coinIcon, "coin icon")}
  //           <div>Exclusive Discounts</div>
  //           <div>
  //             We negotiate discounts with all of our suppliers, meaning you
  //             can’t find these prices anywhere else
  //           </div>
  //         </Col>
  //       </Row>
  //       <Row className="plans__section__description">
  //         <Col
  //           xs={12}
  //           sm={12}
  //           md={4}
  //           lg={3}
  //           className="plans__section__description_card"
  //         >
  //           {this.renderIconContainer(invoiceIcon, "invoice Icon")}
  //           <div>Branded Invoicing</div>
  //           <div>
  //             Build your brand by adding your logo to customer’s invoices
  //             (select suppliers only)
  //           </div>
  //         </Col>
  //         <Col
  //           xs={12}
  //           sm={12}
  //           md={4}
  //           lg={3}
  //           className="plans__section__description_card"
  //         >
  //           {this.renderIconContainer(chatIcon, "chat Icon")}
  //           <div>24/7 Support</div>
  //           <div>
  //             Get the right answers, at the right time with instant chat and
  //             phone support
  //           </div>
  //         </Col>
  //         <Col
  //           xs={12}
  //           sm={12}
  //           md={4}
  //           lg={3}
  //           className="plans__section__description_card"
  //         >
  //           {this.renderIconContainer(bulkCheckout, "bulk Checkout")}
  //           <div>Bulk Order Checkout</div>
  //           <div>
  //             Checkout multiple orders at once with the click of a button
  //           </div>
  //         </Col>
  //       </Row>
  //       <Row className="plans__section__description">
  //         <Col
  //           xs={12}
  //           sm={12}
  //           md={4}
  //           lg={3}
  //           className="plans__section__description_card"
  //         >
  //           {this.renderIconContainer(executiveAccount, "executive Account")}
  //           <div>Dedicated Account Executive</div>
  //           <div>
  //             Your own Spocket Account Executive who is always available to give
  //             you a hand
  //           </div>
  //         </Col>
  //         <Col
  //           xs={12}
  //           sm={12}
  //           md={4}
  //           lg={3}
  //           className="plans__section__description_card"
  //         >
  //           {this.renderIconContainer(productRequest, "product Request")}
  //           <div>Product Requests</div>
  //           <div>
  //             Looking for something specific? Request products that aren’t
  //             already on Spocket
  //           </div>
  //         </Col>
  //         <Col
  //           xs={12}
  //           sm={12}
  //           md={4}
  //           lg={3}
  //           className="plans__section__description_card"
  //         >
  //           {this.renderIconContainer(paperIcon, "paperIcon")}
  //           <div>Unlimited Orders</div>
  //           <div>
  //             There is no limit to the amount of money you can make with Spocket
  //           </div>
  //         </Col>
  //       </Row>
  //     </div>
  //   );
  // };

  // ? This is not used, maybe remove? 
  // renderRatedSection = () => {
  //   return (
  //     <div className="plans__section-rated">
  //       <Row className="plans__section-rated-star">
  //         <Col md={12}>
  //           <img src={fiveStarIcon} alt="Five Star Icon" />
  //         </Col>
  //       </Row>
  //       <Row className="plans__section-rated-dropshippers">
  //         <Col md={12}>
  //           <strong> Rated 5/5</strong> by thousands of Dropshippers
  //         </Col>
  //       </Row>
  //       <Row className="plans__section-rated-cards">
  //         <Col md={6} className="plans__section-card-container">
  //           <div className="plans__section-card">
  //             <img src={avatar01} alt="Avatar 01" />
  //             <div className="plans__section-card-rated-title">
  //               "I knew pretty early in my twenties that traditional 9-5 wasn't
  //               for me. E-Commerce and social media marketing seemed like a
  //               natural choice for me. The day I left my traditional job to
  //               become my own boss was the best feeling. The team at Spocket has
  //               helped provide the tools for me to grow into a six figure earner
  //               in less than 4 months. The support they offer and the selection
  //               of items they have are the best out there. Thanks guys!"
  //             </div>
  //             <div className="plans__section-card-rated-footer">
  //               -Erin Rafferty
  //             </div>
  //           </div>
  //         </Col>
  //         <Col md={6} className="plans__section-card-container">
  //           <div className="plans__section-card">
  //             <img src={avatar02} alt="Avatar 02" />
  //             <div className="plans__section-card-rated-title">
  //               “As someone who is familiar with the dropshipping space and the
  //               multitude of supplier options available to store owners, I
  //               believe that Spocket is the best option of them all. With filter
  //               options such as American Made products, Ethically Sourced
  //               products, High Inventory Products, among others, their product
  //               selection is amazing. Their staff is also one of the best I've
  //               dealt with, always making sure you're taken care of. Spocket is
  //               already a great platform, and they will only get better as they
  //               are constantly making improvements. Can't wait to see what the
  //               future holds!”
  //             </div>
  //             <div className="plans__section-card-rated-footer">
  //               -Daron Balayan
  //             </div>
  //           </div>
  //         </Col>
  //       </Row>
  //     </div>
  //   );
  // };

  // ? This is not used, maybe remove? 
  // renderQuestionSection = () => {
  //   let questions = data.questions;

  //   if (isIntegratedStoreWix()) {
  //     questions = questions.slice(2); // Remove the questions related to trial
  //   }

  //   return (
  //     <Accordion>
  //       {questions.map(question => {
  //         return (
  //           <AccordionItem>
  //             <AccordionItemHeading>
  //               <AccordionItemButton>{question.title}</AccordionItemButton>
  //             </AccordionItemHeading>
  //             <AccordionItemPanel>
  //               <p>{question.body}</p>
  //             </AccordionItemPanel>
  //           </AccordionItem>
  //         );
  //       })}
  //     </Accordion>
  //   );
  // };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handleUpgradeRequest,
      setAlertMessage,
      getPaymentSettings,
      showModal,
      isAnnual,
      fetchEmpireProrationPrice
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    url: state.upgrade.url,
    error: state.upgrade.error,
    tracker: state.sharedComponents.tracker,
    hasStripe: state.settings.stripeCustomerId,
    annualIsChecked: state.upgrade.annualIsChecked,
    eventId: state.eventTracker.eventId,
    proratedEmpireCost: state.settings.proratedEmpireCost,
    role: state.settings.dropshipperData.role,
    maxDiscountPercentage: state.store.plans.maxDiscountPercentage,
    dropshipperData: state.settings.dropshipperData,
    dataModal: state.ui.data
  };
}

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Plans)
);



// WEBPACK FOOTER //
// ./src/components/Plans/index.js